import * as React from 'react';
import l10n from '../../util/l10n';
import ModuleData from './ModuleData';
import { WebViewProps } from '../interfaces';
import ModulHeader from '../ModulHeaderHeading';

export interface HeadingWebViewProps extends WebViewProps<ModuleData>, React.Props<HeadingWebView> {
    module: ModulHeader;
}

export default class HeadingWebView extends React.Component<HeadingWebViewProps, {}> {

    private headingContainer: HTMLElement;

    componentDidMount() {
        this.props.module.initCKEditor(this.headingContainer);
    }

    render() {

        const headingValue = this.props.payload.header === ''
            ?  '<< ' + l10n('module.heading.newheading') + ' >>'
            :
            this.props.payload.header;

        // Extra span used by some layouts for decorative effects.
        // Needs this class so it's not confused with other spans
        // inside the heading, such as semantic placeholders.
        // See DHDIYW-1862 for details.
        const SpanHeading =
            <span
                className="diyfeDecoration"
                dangerouslySetInnerHTML={{ __html: headingValue }}
            />;

        return (
            <div ref={(headingContainer) => this.headingContainer = headingContainer}>
                {
                    this.props.payload.h === "2" ?
                    <h2>
                        {SpanHeading}
                    </h2>
                    :
                    <h1>
                        {SpanHeading}
                    </h1>
                }
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/heading/WebView.tsx
 **/